import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ShieldCheck } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { onReauthRequest } from "@/lib/reauth";

export function ReauthDialog() {
  const [req, setReq] = useState(null);
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => onReauthRequest((r) => { setPw(""); setErr(""); setReq(r); }), []);

  const close = () => { req?.reject(new Error("cancelled")); setReq(null); };
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/reauth", { password: pw });
      req.resolve(data.reauth_token); setReq(null);
    } catch (e2) { setErr(formatApiError(e2?.response?.data?.detail)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!req} onOpenChange={(o) => !o && close()}>
      <DialogContent className="bg-card sm:max-w-sm" data-testid="reauth-dialog">
        <DialogHeader><DialogTitle className="font-head flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-amber-500" /> Confirm it's you</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <p className="text-sm text-muted-foreground">This is a sensitive action. Re-enter your password to continue.</p>
          <Input type="password" autoFocus value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Your password" data-testid="reauth-password" />
          {err && <p className="text-sm text-rose-500" data-testid="reauth-error">{err}</p>}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={close}>Cancel</Button>
            <Button type="submit" disabled={busy || !pw} data-testid="reauth-submit">{busy ? "Verifying…" : "Confirm"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
